// extracted by mini-css-extract-plugin
export var downArrow = "_94-0";
export var label = "_94-1";
export var treatmentCard = "_94-3";
export var upArrow = "_94-2";